'use strict';/* global define */define('modules/quick-feedback/values/trophy-scale/index',['require','exports','module'],function(require,exports,module){'use strict';module.exports={0:'bronze',0.5:'silver',1:'gold'};});
